







































































































































































import Vue from 'vue'
import { CommentService } from '@/services'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import Post from '@/models/Post'
import Product from '@/models/Product'
import Category from '@/models/Category'
import { getMobileTheme } from '@/helper'
import {
  userAvatarImage,
  COMMENT_MAX_LENGTH,
  MOBILE_HEADING_MAX_LENGTH
} from '@/helper/constants'
import UserAvatar from '@/components/common/UserAvatar.vue'
import MobileOneComment from './MobileOneComment.vue'
import UISpinner from '../common/UISpinner.vue'
import Editor from '@tinymce/tinymce-vue'
import { mobileCommentEditorConfig } from '@/helper/constants'

export default Vue.extend({
  props: {
    product: {
      type: Object as Product
    },
    activePost: {
      type: Object as Post
    },
    category: {
      type: Object as Category
    },
    instructor: {
      type: Object
    }
  },
  components: {
    UISpinner,
    BaseIcon,
    UserAvatar,
    MobileOneComment,
    Editor
  },
  data() {
    return {
      emptyAvatar: userAvatarImage,
      fetching: false,
      posting: false,
      isUpdating: false,
      userComment: '',
      commentMaxLength: COMMENT_MAX_LENGTH,
      comments: [],
      commentsLimit: 5,
      commentsOffset: 0,
      hideLoadMoreComments: false,
      replyToUser: null,
      editCommentData: null,
      isCommentReplyView: false,
      editorConfig: mobileCommentEditorConfig,
      editorId: 'mobile-comment-textarea'
    }
  },
  async mounted() {
    await this.fetchComments()
    this.updateRedirectToPost()
  },
  computed: {
    productId() {
      return this.$route.params.id
    },
    postId() {
      return this.$route.params.post_id
    },
    categoryId() {
      return this.$route.params.category_id
    },
    userAvatar() {
      return this.$store.getters.userAvatar || userAvatarImage
    },
    postButtonText() {
      if (this.replyToUser) {
        return 'Reply'
      } else if (this.editCommentData) {
        return 'Update'
      }

      return 'Post'
    },
    replyViewParentComment() {
      return this.isCommentReplyView && this.comments.length
        ? this.comments[0]
        : null
    },
    replyViewParentCommentUserName() {
      return this.replyToUser ? this.replyToUser.name : 'Instructor'
    },
    showCloseReplyButton() {
      return this.isCommentReplyView && !this.editCommentData
        ? this.replyToUser?.commentId !== this.replyViewParentComment?.id
        : true
    },
    editorInstance() {
      return window.tinyMCE
    },
    commentListEle() {
      return this.$refs.commentList
    },
    currentCommentLength() {
      return this.userComment
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/&nbsp;/g, ' ').length
    },
    showPostButton() {
      return (
        this.currentCommentLength &&
        this.currentCommentLength <= this.commentMaxLength
      )
    }
  },
  methods: {
    async fetchComments(commentId, overWrite = false) {
      this.fetching = true
      try {
        const { data } = await CommentService.findComments({
          postId: this.postId,
          productId: this.productId,
          limit: commentId ? 1 : this.commentsLimit,
          offset: commentId ? 0 : this.commentsOffset,
          order: -1,
          commentId: commentId ? commentId : ''
        })

        if (!data.comments.length) {
          this.hideLoadMoreComments = true
          return
        }

        this.comments = overWrite
          ? data.comments
          : this.comments.concat(data.comments)
        this.commentsOffset += this.commentsLimit
      } catch (error) {
        console.error('Error while fetching comments --> ', error)
      } finally {
        this.fetching = false
      }
    },
    async createComment() {
      if (!this.userComment) {
        return
      }
      this.posting = true
      try {
        const { data } = await CommentService.createComment({
          postId: this.postId,
          productId: this.productId,
          content: this.userComment,
          pendoPayload: {
            postTitle: this.activePost.title,
            productTitle: this.product.title,
            categoryTitle: this.category.title
          }
        })

        if (data.error) {
          throw data.error
        }

        this.addNewCommentToLocalState({
          ...data.comment,
          replies: []
        })
        this.eraseWrittenComment()
        this.commentListEle.scrollTop = 0
        this.removeEditorFocus()
      } catch (error) {
        console.error('Error while creating comment --> ', error)
      } finally {
        this.posting = false
      }
    },
    async updateComment() {
      this.isUpdating = true
      const commentId = this.editCommentData.id
      try {
        await CommentService.updateComment(commentId, {
          content: this.userComment,
          pendoPayload: {
            postTitle: this.activePost.title,
            productTitle: this.product.title,
            categoryTitle: this.category.title
          }
        })
        this.updateCommentInLocalState({
          id: commentId,
          content: this.userComment
        })
        this.eraseWrittenComment()
        this.removeEditorFocus()
      } catch (error) {
        console.error('Error while updating comment --> ', error)
      } finally {
        this.isUpdating = false
      }
    },
    async deleteComment(commentId) {
      try {
        await CommentService.deleteComment(commentId)
        this.deleteCommentFromLocalState(commentId)
        if (
          this.isCommentReplyView &&
          this.replyToUser &&
          commentId === this.replyToUser.commentId
        ) {
          await this.showAllComments()
        }
      } catch (error) {
        console.error('Error while deleting comment --> ', error)
      }
    },
    updateCommentInLocalState(commentData) {
      const { id: commentId } = commentData
      this.comments = this.comments.map(comment => {
        if (comment.id !== commentId && !comment.replies.length) return comment

        if (comment.id !== commentId) {
          comment.replies = comment.replies.map(reply => {
            if (reply.id === commentId) {
              return {
                ...reply,
                content: commentData.content
              }
            }
            return reply
          })

          return comment
        }
        return {
          ...comment,
          content: commentData.content
        }
      })
    },
    deleteCommentFromLocalState(commentId) {
      this.comments = this.comments.filter(comment => {
        if (comment.id !== commentId && !comment.replies.length) return true

        if (comment.id !== commentId) {
          comment.replies = comment.replies.filter(reply => {
            if (reply.id === commentId) {
              return false
            }
            return true
          })

          return true
        }
        return false
      })
    },
    addNewCommentToLocalState(newComment, isReply = false) {
      if (isReply) {
        const commentIndex = this.comments.findIndex(
          cmt => cmt.id === this.replyToUser.parentCommentId
        )
        if (commentIndex > -1) {
          this.comments[commentIndex].replies.push(newComment)
        }
        return
      }

      this.comments.unshift(newComment)
      this.commentsOffset += 1
    },
    async replyToComment() {
      if (!this.userComment) {
        return
      }
      this.posting = true
      try {
        const { data } = await CommentService.createComment({
          postId: this.postId,
          productId: this.productId,
          content: this.userComment,
          parentCommentId: this.replyToUser.parentCommentId,
          repliedToComment: this.replyToUser.repliedToComment,
          repliedToUserId: this.replyToUser.repliedToUserId,
          pendoPayload: {
            postTitle: this.activePost.title,
            productTitle: this.product.title,
            categoryTitle: this.category.title
          }
        })

        if (data.error) {
          throw data.error
        }

        this.addNewCommentToLocalState({ ...data.comment, replies: [] }, true)
        this.eraseWrittenComment(false, { skipNameTag: true })
        this.removeEditorFocus()
      } catch (error) {
        console.error('Error while replying to comment --> ', error)
      } finally {
        this.posting = false
      }
    },
    updateReplyToUser(user, eraseContent = true, extraConfig) {
      if (this.replyToUser && this.replyToUser.commentId === user.commentId)
        return
      if (eraseContent) this.eraseWrittenComment(true)

      this.replyToUser = user ? user : null

      if (extraConfig && extraConfig.skipNameTag) return
      this.editorInstance.execCommand(
        'mceInsertContent',
        false,
        user.name ? `@${user.name.replace(' ', '')} ` : ''
      )
    },
    updateEditComment(commentData) {
      this.eraseWrittenComment(true)
      this.editCommentData = commentData ? commentData : null
      this.userComment = commentData ? commentData.content : ''
      this.editorInstance.execCommand(
        'mceInsertContent',
        false,
        this.userComment
      )
    },
    eraseWrittenComment(skipReplyUpdate = false, extraConfig = null) {
      this.editCommentData = null
      this.replyToUser = null
      this.userComment = ''
      this.editorInstance.execCommand('mceSetContent', false, '')
      if (this.isCommentReplyView && !skipReplyUpdate) {
        const comment = this.replyViewParentComment
        this.updateReplyToUser(
          this.extractCommentData(comment),
          false,
          extraConfig
        )
      }
    },
    getPostFunction() {
      if (!this.showPostButton) {
        return null
      }
      return this.replyToUser
        ? this.replyToComment()
        : this.editCommentData
        ? this.updateComment()
        : this.createComment()
    },
    extractCommentData(comment) {
      return {
        commentId: comment.id,
        ...comment,
        parentCommentId: comment.parentCommentId
          ? comment.parentCommentId
          : comment.id,
        avatar: comment.userdetails ? comment.userdetails.avatar : '',
        name: comment.userdetails ? comment.userdetails.name : ''
      }
    },
    updateBackData(params) {
      this.$emit('updateBackData', params)
    },
    updateRedirectToPost() {
      this.updateBackData({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.categoryId,
          post_id: this.postId
        }
      })
    },
    resetLimitAndOffset() {
      this.commentsLimit = 5
      this.commentsOffset = 0
    },
    async openCommentReplies(comment) {
      this.fetching = true
      await this.fetchComments(comment.id, true)
      this.fetching = false

      this.updateReplyToUser(this.extractCommentData(comment))
      this.isCommentReplyView = true

      this.updateBackData({
        callback: this.showAllComments
      })
    },
    async showAllComments() {
      this.fetching = true
      this.resetLimitAndOffset()
      await this.fetchComments(null, true)
      this.fetching = false

      this.isCommentReplyView = false
      this.eraseWrittenComment()

      this.updateRedirectToPost()
    },
    removeEditorFocus() {
      const editor = this.editorInstance.get('mobile-comment-textarea')
      if (editor) editor.iframeElement.blur()
    },
    getMobileTheme
  },
  filters: {
    truncatePostTitle(title) {
      return title && title.length > MOBILE_HEADING_MAX_LENGTH
        ? title.slice(0, MOBILE_HEADING_MAX_LENGTH) + '...'
        : title
    }
  }
})
